<div class="container-fluid-modal">
    <div class="invoiceWrapper">
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-10">
                <div class="card">
                    <div class="card-body">
                        <div class="headerWrapper">
                            <h4> Tracking - Active Implants </h4> 
 
                            <div class="col-lg-6"> 
                               <button  *ngIf="mobile === true" type="button"class="btn btn-success btn-sm"   id="{{myToken}}"  mat-raised-button  onClick="scanRfid(this.id)"><i class="fa fa-cloud-upload"  aria-hidden="true"></i>
                             Scan RFID
                             </button>
                            </div>


                            <div class="col-lg-6">
                               <button type="button"class="btn btn-success btn-sm"   id="{{myToken}}"  mat-raised-button  onClick="scanRfid(this.id)">
                         <i aria-hidden="true" class="fa fa-barcode"></i>
                             Scan RFID
                             </button>
                            </div>
 

                        </div>
                        <div class="customModal">
                        </div>
                        <table class="table table-bordered" *ngIf="viewPermission === true">
                            <thead>
                                <tr>
                                    <th class="col1" scope="col">UID</th>
                                    <th class="col2" scope="col">Product Code</th>
                                    <th class="col3" scope="col">Product Name</th>
                                    <th class="col4" scope="col">City</th>
                                    <th class="col5" scope="col">Store</th>
                                    <th class="col6" scope="col">Updated On</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr rowspan="" *ngFor="let item of tracking | slice: 0:10| paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index " (click)="selectRow(i)" [ngClass]="{'sel': i === selectedIndex }" (dblclick)="openTrackingModal(item.stock_id)" style="height: 36px;">
                                    <!-- <th scope="row">{{item.id}}</th> -->

                                    <td class="col10">{{item.stock_id}}</td>
                                    <td class="col11">{{item.product_id}}</td>
                                    <td class="col12">{{item.product_name}}</td>
                                    <td class="col13">{{item.location_name}}</td>
                                    <td class="col14">{{item.store_name}}</td>
                                    <td class="col15">{{item.date_displacement}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="footerWrapper row">
                            <div class="col-lg-7 col-md-12 col-sm-12">
                                <div class="input-group">
                                    <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true" class="form-control border" (change)="getSearchValue()">
                                    <option name="productNoName" value="0"> Search by Product Name</option>
                                    <option name="cityNoName" value="1"> Search by City Name</option>
                                    <option name="storeNoName" value="3"> Search by Store Name</option>
                                    </select>
                                                                
                                    <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">
                                    <span class="input-group-text" (click)="doSearch()">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                    <span class="input-group-text" (click)="doRefresh()">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </span>    
                                </div>
                            </div>                            
                            <div class="col-lg-5 col-md-12 col-sm-12">
                                    <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                                    </app-common-page>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"> </div>

        </div>


    </div>


</div>
